<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="2" class="back-icon-button">
        <router-link :to="'/class/' + $route.params.class_id + '/discussions'" class="icon-link">
          <i class="el-icon-chat-line-round discussion-title-icon"></i>
        </router-link>
        <div class="back-to-list-text">Back</div>
      </el-col>
      <el-col :span="22">
        <div class="discussion-title">{{ name }}</div>
        <div class="avatar-container">
          <div :style="`background-image: url(${author.avatar});`" class="avatar-img" />
          <span class="avatar-text">
            <span class="author-name">{{ author.name }}</span>
            <span class="release-time">{{ release_time }}</span>
          </span>
        </div>
        <div class="field-container">
          <div class="title">Description</div>
          <MarkdownDisplay :value="description" />
          <div class="title">Attachment</div>
          <FileDownloadCard :href="attachment" />
        </div>
        <CommentList :comments="comments" @refresh-comments="refreshComments">
          <div class="input-wrapper">
            <el-input
              class="gray-bg-input"
              v-model="inputComment"
              type="textarea"
              :rows="3"
              autofocus
              placeholder="Write down your comments here..."
            ></el-input>
            <div class="btn-control">
              <el-button type="text" class="cancel" @click="cancelComment">Cancel</el-button>
              <el-button type="primary" round @click="commitComment">Commit</el-button>
            </div>
          </div>
        </CommentList>
      </el-col>
    </el-row>
    
  </div>
</template>

<script>
import { getDiscussionWithCommentsById, postDiscussionComment } from "@/api";
import MarkdownDisplay from "@/atoms/MarkdownDisplay.vue";
import FileDownloadCard from "@/atoms/FileDownloadCard.vue";
import CommentList from "@/components/CommentList.vue";

export default {
  name: "DiscussionDetails",
  components: {
    MarkdownDisplay,
    FileDownloadCard,
    CommentList
  },
  data() {
    return {
      name: "",
      description: "",
      release_time: "",
      attachment: "",
      author: {
        name: "",
        avatar: ""
      },
      comments: [],
      inputComment: ""
    };
  },
  mounted() {
    this.getDiscussionDetails();
  },
  methods: {
     refreshComments() {
      this.getDiscussionDetails();
    },
    getDiscussionDetails() {
      getDiscussionWithCommentsById(this.$route.params.discussion_id).then(
        res => {
          this.name = res.name;
          this.description = res.description;
          this.release_time = res.release_time;
          this.attachment = res.attachment;
          this.author = res.author;
          this.comments = res.comments;
        }
      );
    },
    cancelComment() {
      this.inputComment = "";
    },
    commitComment() {
      const content = this.inputComment;
      const userId = this.$store.state.userId;
      const discussionId = this.$route.params.discussion_id;
      if (content && userId && discussionId) {
        postDiscussionComment(content, discussionId, userId).then(res => {
          if (res && res.id) {
            this.$message({
              type: "suceess",
              message: "Comment Committed!"
            });
            this.inputComment = "";
            this.refreshComments();
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$text-normal: #606266;
$text-333: #333;
.back-icon-button {
  color: rgba(0, 0, 0, 0.49);
  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }
  .icon-link {
    color: inherit;
    .discussion-title-icon {
      font-size: 24px;
      margin: 24px;
      margin-bottom: 8px;
      color: inherit;
    }
  }
  .back-to-list-text {
    font-size: 14px;
    margin-left: 24px;
  }
}

.discussion-title {
  font-size: 24px;
  margin-bottom: 16px;
}
.avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0;
  padding: 4px 0;
  border-bottom: 1px rgba(0, 0, 0, 0.25) solid;
  .avatar-img {
    width: 32px;
    height: 32px;
    background-position: center 10%;
    background-size: cover;
    border: 1px rgba(0, 0, 0, 0.25) solid;
    border-radius: 50%;
    overflow: hidden;
  }
  .avatar-text {
    flex-grow: 1;
    height: 32px;
    line-height: 32px;
    > span {
      height: 100%;
      vertical-align: middle;
    }
    .author-name {
      margin-left: 16px;
      font-size: 14px;
      font-weight: 600;
    }
    .release-time {
      color: rgba(0, 0, 0, 0.25);
      font-size: 12px;
      margin-left: 24px;
    }
  }
}
.field-container {
  margin: 12px 0;
  .title {
    font-size: 20px;
    margin-top: 16px;
    margin-bottom: 12px;
  }
}
.input-wrapper {
  padding: 10px;
  .btn-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 10px;
    .cancel {
      font-size: 16px;
      color: $text-normal;
      margin-right: 20px;
      cursor: pointer;
      &:hover {
        color: $text-333;
      }
    }
    .confirm {
      font-size: 16px;
    }
  }
}
</style>